export default class EventContentItem{
    constructor({
                    category,
                    cid,
                    file,
                    hash,
                    menuId,
                    player,
                    videocontent,
                    imagerelation,
                    videorelation,
                    event,
                    tokenUrl,
                } = {}) {
        this.category = category;
        this.cid = cid;
        this.file = file;
        this.hash = hash?.map(it => it.hashNm);
        this.menuId = menuId;
        this.player = player;
        this.event = event;
        this.videocontent = videocontent?.[0];
        this.imagerelation = imagerelation;
        this.videorelation = videorelation;
        this.tokenUrl = tokenUrl;
    }

}